import React, {useEffect} from 'react';
import {useDispatch} from "react-redux";
import {ResponceStatusService} from "../../sub";
import authService from "../../services/authService";
import {useNavigate} from "react-router-dom";
import { Subscription } from 'rxjs';
import { t } from '../../utils/appString';

const ResponseHandle = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();


    const handleLogout = (redirectPath: string) => {
        // if(redirectPath !== '/Mpin'){
        dispatch(authService.logout());
    // }
        navigate(redirectPath, { replace: true });
    };
    let subscription:Subscription | undefined = undefined
        useEffect(() => {
            subscription = ResponceStatusService.getSub().subscribe((value: any) => {
            if (value?.type === "FLOW" && value?.status === 401) {
                if (value?.url.includes("/aux/authentication/refreshLogin")) {
                    localStorage.removeItem("useRefresh")
                    handleLogout("/");
                } else {
                    // localStorage.setItem("useRefresh", "true");
                    handleLogout(t("routes.mPin"));
                }
            }
        });
        return () => {
            subscription?.unsubscribe();
        };
    }, []);

    return (
        <div>

        </div>
    );
};

export default ResponseHandle;

